import Link from "next/link";
import Head from 'next/head';

const Index = ({
  children,
  classType,
  title1,
  title2,
  url,
  isReserve = true,
  isHeadShow = true,
}) => {
  return (
    <>
      <Head>
        <title>{title1} {title2}</title>
      </Head>
      <div className={classType + ' ' + url + 'Banner'} role="banner">
        <header className="header-repeater pt-4">
          <div className="container">
            <div className="row">
              <div className="col-xl-7 col-lg-7 col-12">
                <Link href="/pillbox">
                  <a className="navbar-brand">
                    <img
                      src="/images/dofaw-logo.png"
                      alt="Hawaii DOFAW logo"
                      width="414"
                      className="img-fluid"
                    />
                  </a>
                </Link>
              </div>

              <div className="col-xl-5 col-lg-5 col-12 link-top text-end">
                {isReserve && (
                  <Link href={"/" + url + "/change"}>
                    <a>Cancel/View Your Reservation</a>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </header>
        <div id="main-content"></div>

        {isHeadShow && (
          <div className="container">
            <h1 className="display-1">
              {title1}
              <span className="Hide">
                <br />
              </span>{" "}
              {title2}
            </h1>
            {children}
          </div>
        )}
      </div>
      <div className="blue"></div>
    </>
  );
};

export default Index;
